import { ReactNode } from 'react';

import { useAutoNavigate } from '@betterment/js-runtime';
import { Box, IconButton, PancakeStack, WorkflowHeader } from '@betterment/samba-react';

import { GraphQLProvider } from '../../../providers/GraphQLProvider';
import { IdempotencyProviderWithFeatureRegistry } from '../../../providers/IdempotencyProviderWithFeatureRegistry';
import urlBuilder from '../../../Shared/url-builder';
import Footer from '../../Footer';

interface FlowLayoutProps {
  children: ReactNode;
  leading?: ReactNode;
}

export const FlowLayout = ({ children, leading }: FlowLayoutProps) => {
  const navigate = useAutoNavigate();

  return (
    <GraphQLProvider>
      <IdempotencyProviderWithFeatureRegistry featureName="onDemandBilling">
        <PancakeStack css={{ maxWidth: '100%' }}>
          <PancakeStack.Header
            css={{
              maxWidth: '100%',
              display: 'flex',
              justifyContent: 'center',
              borderBottomStyle: 'solid',
              borderBottomWidth: 'thin',
              borderColor: 'border',
            }}
          >
            <WorkflowHeader css={{ width: '100%' }}>
              <WorkflowHeader.Leading>
                <Box css={{ display: 'flex', gap: 'space.800', alignItems: 'center' }}>{leading}</Box>
              </WorkflowHeader.Leading>
              <WorkflowHeader.Title>Upload fees</WorkflowHeader.Title>
              <WorkflowHeader.Trailing>
                <IconButton
                  name="X"
                  label="Exit"
                  spacing="compact"
                  onClick={() => void navigate(urlBuilder.getOnDemandBillingIndexPage.absolutePath)}
                />
              </WorkflowHeader.Trailing>
            </WorkflowHeader>
          </PancakeStack.Header>
          <PancakeStack.Main
            css={{
              maxWidth: '100%',
              pt: 'space.400',
            }}
          >
            {children}
          </PancakeStack.Main>
          <PancakeStack.Footer
            css={{
              px: 'space.200',
              paragraphSpacing: true,
            }}
          >
            <Footer />
          </PancakeStack.Footer>
        </PancakeStack>
      </IdempotencyProviderWithFeatureRegistry>
    </GraphQLProvider>
  );
};
